<script lang="ts">
  import { dispatch, PassportEvents } from '@lib/events/events'
  import { loadScript } from '@lib/scripts/scripts'
  import { pageOptsStore, pageStore } from '@packages/stores'
  import { Pages } from '@packages/utils/enums'
  import { toastAlert } from '@src/passport/ui'
  import { onMount } from 'svelte'
  import { createOrder, processOrder } from '../order.service'
  import { afterPaymentProcess } from '../Payment.service'
  import { get } from 'svelte/store'
  import { configStore } from '@src/stores/config'
  import Button from '@packages/ui/main/shared/inputs/button/Button.svelte'
  import { getClientTokenConfig } from '@lib/clients'
  import { getOrderDetails } from '@lib/orders'

  let { priceCents, purchaseConfig, isLoading = $bindable(), feeToApply, idempotencyKey } = $props()

  let Paystack: Window['PaystackPop']

  onMount(async () => {
    try {
      if (!Paystack) {
        if (!window.PaystackPop) {
          await loadScript('https://js.paystack.co/v2/inline.js')
        }
        Paystack = window.PaystackPop
      }
    } catch (err) {
      return console.log('Please include paystack to use payments.')
    }
  })

  const externalErrorHandler = (err: Error) => {
    isLoading = false
    toastAlert(`Payment error: ${err.message || err}`, 'failure')
    pageOptsStore.set({ errorMessage: err.message })
    pageStore.set(Pages.ERROR)
    dispatch(PassportEvents.ERROR, { error: err })
  }

  const doPayment = async () => {
    try {
      const { assets } = purchaseConfig
      const config = get(configStore)
      if (!assets?.length) throw new Error('No purchase config assets found')
      isLoading = true

      const currency = getClientTokenConfig().payment.paystack!
      const orderId = await createOrder(
        {
          assets,
          payment_provider: 'paystack',
          client_id: get(configStore).clientId,
          currency,
        },
        idempotencyKey,
      )
      const res = await getOrderDetails(config.credenza.generalApiUrl, orderId)

      if (!res.payment_provider_data?.access_code) throw new Error('Payment is unavailable now')
      const popup = new Paystack()

      const result = popup.resumeTransaction(res.payment_provider_data?.access_code)
      result.onSuccess = async () => {
        try {
          const res = await processOrder(orderId)
          await afterPaymentProcess({
            res,
            priceCents,
            purchaseConfig,
          })
        } catch (err) {
          externalErrorHandler(err)
        } finally {
          isLoading = false
        }
      }

      result.onError = (err: unknown) => {
        isLoading = false
        throw err
      }

      result.onCancel = () => {
        isLoading = false
        throw new Error('Payment was not finished')
      }
    } catch (err) {
      externalErrorHandler(err)
    }
  }
</script>

<div class="crtw-w-full crtw-text-center crtw-my-5">
  <Button text={`Pay with Mobile Money`} onClick={doPayment} disabled={false} isLoading={false} />
  {#if feeToApply}
    <span class="crtw-text-xs crtw-text-stone-200">Fee of {feeToApply * 100}% is automatically added.</span>
  {/if}
</div>
